import { Container, Typography } from "@mui/material";
import { Grid, Card } from "@mui/material";
import React from "react";

export default function MyTeam() {
  return (
    <Grid container justifyContent="center" rowSpacing={4} columnSpacing={12}>
      <Grid item xs={12} sm={6} md={8}>
        <Card
          sx={{
            padding: "20px",
            display: "flex",
            flexDirection: {xs:"column", md:"row"},
            alignItems: "center",
          }}
        >
          <Container>
            <img
              src="https://edrusslaw-wziller.s3.us-east-2.amazonaws.com/profile-ed.jpg"
              style={{
                width: "100%",
                borderRadius: "50%",
                objectFit: "cover",
                aspectRatio: "initial",
              }}
              alt="Edward Russell"
            />
          </Container>
          <Container>
            <Typography variant="h4">Edward Russell</Typography>
            <br></br>
            <Typography variant="body" sx={{ fontSize:"14pt"}}>
              A graduate from St. Mary’s School of Law, Ed is also a military
              scientist and war veteran, a former Captain in the U.S. Air Force.
              Whether you’ve been in a car accident or were injured on
              professional premises, he’s who you want strategizing your
              success.
            </Typography>
          </Container>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6} md={8}>
        <Card
          sx={{
            padding: "20px",
            display: "flex",
            flexDirection: {xs:"column", md:"row"},
            alignItems: "center",
          }}
        >
          <Container>
            <img
              src="https://edrusslaw-wziller.s3.us-east-2.amazonaws.com/profile-liz.jpg"
              style={{
                width: "100%",
                borderRadius: "50%",
                objectFit: "cover",
                aspectRatio: "initial",
              }}
              alt="Elizabeth Cunningham"
            />
          </Container>
          <Container>
            <Typography variant="h4">Elizabeth Cunningham</Typography>
            <br></br>
            <Typography variant="body" sx={{ fontSize:"14pt"}}>
              Coming to Edward Russell Law from the largest defense firm in San
              Antonio, Liz brings a strong results-oriented background to our
              firm. Currently my paralegal, Liz is also preparing to take the
              Texas Bar. I look forward to adding her practice areas to my
              offered services.{" "}
            </Typography>
          </Container>
        </Card>
      </Grid>
    </Grid>
  );
}
